export const initialStateStatus = {
  state: {
    isFetching: false,
    isSuccess: false
  }
}